import { render, staticRenderFns } from "./MADD.vue?vue&type=template&id=1f95a02c&scoped=true"
import script from "./MADD.vue?vue&type=script&lang=js"
export * from "./MADD.vue?vue&type=script&lang=js"
import style0 from "./MADD.vue?vue&type=style&index=0&id=1f95a02c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f95a02c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f95a02c')) {
      api.createRecord('1f95a02c', component.options)
    } else {
      api.reload('1f95a02c', component.options)
    }
    module.hot.accept("./MADD.vue?vue&type=template&id=1f95a02c&scoped=true", function () {
      api.rerender('1f95a02c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Search/Result/MADD.vue"
export default component.exports